module.exports = __webpack_public_path__ + "img/traffic-vps.aa00c67 1.419838f.svg";